// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab4b879c","239":"ffbcaa0d","453":"58a7a83b","455":"5ca6e3ca"}[chunkId] + ".chunk.js";
};